module.exports = __webpack_public_path__ + "static/media/Paperclip.a0c8a942.svg";